const tableTitleManagementEquip = {
  title: 'Equipments',
  placeholder: 'Search by the fields: serial number, brand, description, and reference',
  helperTextSearch: 'To search by equipment name, use the equipment model filter',
  addRowLabel: 'new equipment'
};

export default tableTitleManagementEquip;
